export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">联系我们</h2>
          <p className="text-sm text-foreground-500 mb-8">
            如有资源建议、内容投稿或合作意向，欢迎通过以下方式联系老子影视网团队。
            我们重视每一位影迷的反馈，共同打造更好的高清影视观影平台。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                <i className="ri-mail-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-1">投稿邮箱</h3>
              <span className="text-xs text-foreground-500">contact@laozimovie.com</span>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                <i className="ri-wechat-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-1">官方微信</h3>
              <span className="text-xs text-foreground-500">老子影视网</span>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mx-auto mb-3">
                <i className="ri-feedback-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-1">意见反馈</h3>
              <span className="text-xs text-foreground-500">在线提交反馈建议</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}